export enum EntityViewTypes {
  listView = "listView",
  kanbanBoardView = "kanbanBoardView",
  timelineView = "timelineView",
  mapView = "mapView",
}
